import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "In-state: Arkansas Passport Center, Hot Springs (local)",
      "NPIC appointment required — the agency is right here in Hot Springs",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — agency is local (Hot Springs)",
      "Ideal for National Park visitors with sudden international plans",
      "Perfect for spa convention attendees and hospitality pros",
      "Great for Hot Springs retirees booking global tours",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Hot Springs post offices",
      "Good for planned international trips from LIT",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Garland County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function HotSpringsProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Hot Springs, AR"
      introText="Hot Springs travelers — convention attendees heading to international spa and hospitality trade shows, National Park visitors who book last-minute overseas trips after falling in love with the Ouachitas, active retirees planning European spa tours and Caribbean cruises, and Garland County families with international vacation plans — have several options for getting a passport fast. Here is how they compare, and why most Hot Springs residents choose a U.S. Department of State registered passport courier for predictable, professional processing. The Arkansas Passport Center is right here at 400 N College Ave."
      options={options}
      emergencyDescription="The Arkansas Passport Center is located right here in Hot Springs at 400 N College Ave. For life-or-death emergencies, call NPIC at 1-877-487-2778 to book an appointment at 400 N College Ave, Hot Springs, AR 71901. No walk-ins accepted — appointments required."
      disclaimerText="*Processing speed depends on eligibility and documentation. Hot Springs is home to the Arkansas Passport Center at 400 N College Ave. Not all applicants qualify for Regional Agency Processing."
    />
  );
}